import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Document, Page, pdfjs } from 'react-pdf';
import {
  getAllTegsThunk,
  getLiveChatAgentIdThunk,
  patchQaChatChekedResultThunk,
  patchQaChatChekedThunk,
} from '../../../redux/qa/qaActions';
import {
  selectAccessToken,
  selectQaChatsAgent,
  selectQaChatsAllTegs,
} from '../../../redux/selectors';
import { Notify } from 'notiflix';
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  ChatInfoSection,
  ChatInfoLeft,
  ChatId,
  ChatStatus,
  StatusIcon,
  UserSection,
  UserAvatar,
  UserInfo,
  UserName,
  UserRole,
  UserStats,
  StatItem,
  StatValue,
  StatLabel,
  ProgressSection,
  ProgressBar,
  Progress,
  TabContainer,
  Tab,
  TabContent,
  AnalyticsList,
  AnalyticsItem,
  AnalyticsItemHeader,
  AnalyticsItemTitle,
  AnalyticsItemScore,
  AnalyticsItemContent,
  ChatContainer,
  MessageContainer,
  MessageBubble,
  MessageHeader,
  MessageAuthor,
  MessageTime,
  MessageContent,
  ActionButtons,
  ActionButton,
  CommentModal,
  CommentModalContent,
  CommentForm,
  FormField,
  Label,
  Input,
  TextArea,
  SubmitButton,
  ResetIcon,
  DoneIcon,
  DicisionIcon,
  Plus,
  Minus,
  CommentText,
  TextBlock,
  List,
  Item,
} from './SupportMenu.styled';
import imgTest from '../../../images/userPhoto.png';

const SupportMenu = ({ userId, chats, switcher, onClose }) => {
  const [activeTab, setActiveTab] = useState('analytics');
  const [openTextIndex, setOpenTextIndex] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [modalDataAgent, setModalDataAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    comment: '',
    tags: [],
    decision: false,
  });
  const [searchQuery, setSearchQuery] = useState('');
  const commentModalRef = useRef(null);
  const mainModalRef = useRef(null);

  const dispatch = useDispatch();
  const token = useSelector(selectAccessToken);
  const agent = useSelector(selectQaChatsAgent);
  const allTegs = useSelector(selectQaChatsAllTegs);
  const userDepartment = useSelector(state => state.user.department);
  const [activeUser, setActiveUser] = useState(null);
  const [activeUserResault, setActiveUserResault] = useState(null);
  const [currentChatIndex, setCurrentChatIndex] = useState(0);
  const [currentUserId, setCurrentUserId] = useState(userId);

  // Обработчик клика вне основного модального окна (только когда не открыто модальное окно комментариев)
  useEffect(() => {
    if (isModalOpen) return; // Не добавляем обработчик, если открыто модальное окно комментариев

    const handleClickOutsideMain = (event) => {
      if (mainModalRef.current && !mainModalRef.current.contains(event.target)) {
        onClose?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutsideMain);

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideMain);
    };
  }, [isModalOpen, onClose]);

  // Обработчик клика вне модального окна комментариев
  useEffect(() => {
    if (!isModalOpen) return; // Не добавляем обработчик, если модальное окно комментариев не открыто

    const handleClickOutsideComment = (event) => {
      if (commentModalRef.current && !commentModalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    document.addEventListener('mousedown', handleClickOutsideComment);

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideComment);
    };
  }, [isModalOpen]);

  // Функции для переключения между чатами
  const goToPrevChat = useCallback(() => {
    if (chats && chats.length > 1 && currentChatIndex > 0) {
      const newIndex = currentChatIndex - 1;
      const newUserId = chats[newIndex].pk;
      setCurrentChatIndex(newIndex);
      setCurrentUserId(newUserId);
    }
  }, [chats, currentChatIndex]);

  const goToNextChat = useCallback(() => {
    if (chats && chats.length > 1 && currentChatIndex < chats.length - 1) {
      const newIndex = currentChatIndex + 1;
      const newUserId = chats[newIndex].pk;
      setCurrentChatIndex(newIndex);
      setCurrentUserId(newUserId);
    }
  }, [chats, currentChatIndex]);

  // Установка начального индекса чата
  useEffect(() => {
    if (chats && chats.length > 0) {
      const index = chats.findIndex(chat => chat.pk === userId);
      if (index !== -1) {
        setCurrentChatIndex(index);
        setCurrentUserId(userId);
      }
    }
  }, [userId, chats]);

  // Обновление данных при изменении currentUserId
  useEffect(() => {
    if (currentUserId) {
      dispatch(getLiveChatAgentIdThunk({ token, id: currentUserId }));
    }
  }, [currentUserId, dispatch, token]);

  // Навигация с помощью клавиатуры
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (chats && chats.length > 1) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToPrevChat();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToNextChat();
        }
      }
      if (event.key === 'Escape') {
        if (isModalOpen) {
          closeModal();
        } else {
          onClose?.();
        }
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [currentChatIndex, chats, goToPrevChat, goToNextChat, onClose, isModalOpen]);

  useEffect(() => {
    if (Array.isArray(agent?.username) && agent?.username.length > 0) {
      setActiveUser(prevUser => prevUser || agent.username[0]);
    }
  }, [agent?.username, userId]);

  useEffect(() => {
    if (activeUser) {
      setActiveUserResault(agent?.results);
    }
  }, [activeUser, agent?.results]);

  useEffect(() => {
    dispatch(getAllTegsThunk({ token }));
  }, [dispatch, token]);

  // Блокировка скролла при открытии модального окна
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;

    // Блокируем скролл на body
    document.body.style.overflow = 'hidden';

    // Восстанавливаем скролл при размонтировании компонента
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  const toggleText = index => {
    setOpenTextIndex(prevIndex => (prevIndex === index ? null : index));
  };

  const ChangeChecked = async () => {
    if (userDepartment === 'Supports') {
      Notify.warning('Эта функция недоступна для Support department');
      return;
    }

    const formData = {
      checked: !agent?.checked,
    };

    try {
      await dispatch(patchQaChatChekedThunk({ token, id: currentUserId, formData }));
      Notify.success('Статус проверки обновлен');
    } catch (error) {
      Notify.failure('Ошибка при обновлении статуса');
    }
  };

  const openModal = (item, agentSafe) => {
    if (userDepartment === 'Supports') {
      Notify.warning('Эта функция недоступна для Support department');
      return;
    }
    setModalData(item);
    setModalDataAgent(agentSafe);
    setIsModalOpen(true);

    // Загружаем теги для конкретного вопроса
    if (item?.question) {
      dispatch(getAllTegsThunk({ token, question: item.question }));
    }

    // Устанавливаем начальные данные формы
    setFormData({
      decision: item?.decision || false,
      manager_comment: item?.manager_comment || '',
      tags: item?.tags || [],
    });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
    setModalDataAgent(null);
    setFormData({ comment: '', tags: [], decision: false });
    setSearchQuery('');
  };

  const handleSubmit = async (e) => {
      e.preventDefault();

      try {
        if (!modalData?.pk) {
          console.error('Ошибка: нет ID у modalData');
          return;
        }

        // Формируем правильную структуру данных
        const payload = [
          {
            id: modalData.pk, // ID чата
            decision: formData.decision,
            manager_comment: formData.manager_comment,
            tags: formData.decision
              ? [] // если decision = true, теги очищаются
              : formData.tags.map(tag => tag.id), // отправляем только ID тегов
          },
        ];

        const response = await dispatch(
          patchQaChatChekedResultThunk({
            token,
            formData: payload,
          })
        );

        if (response.meta.requestStatus === 'fulfilled') {
          console.log('Данные успешно обновлены');
          await dispatch(getLiveChatAgentIdThunk({ token, id: userId }));
        closeModal();
        Notify.success('Комментарий добавлен');
        }
      } catch (error) {
        console.error('Ошибка при обновлении данных:', error);
      Notify.failure('Ошибка при добавлении комментария');
    }
  };

  const handleChange = (e, error = null) => {
    const { name, type, checked, value } = e.target;

    // Если изменяется decision checkbox
    if (name === 'decision') {
      setFormData(prev => {
        return {
          ...prev,
          decision: checked,
          tags: checked ? [] : prev.tags, // если decision true, то очищаем теги
        };
      });
    }

    // Если меняется тег (если decision false)
    if (error) {
      setFormData(prev => {
        const isTagSelected = prev.tags.some(tag => tag.id === error.id);

        return {
          ...prev,
          tags: isTagSelected
            ? prev.tags.filter(tag => tag.id !== error.id) // Если выбран, удаляем тег
            : [...prev.tags, error], // Если не выбран, добавляем тег
        };
      });
      setSearchQuery('');
    }

    // Обновляем другие данные в форме
    if (name && name !== 'decision' && name !== 'tags') {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
  };

    const handleSearchChange = e => {
      setSearchQuery(e.target.value);
    };

  // Фильтрация тегов на основе введенного текста
  const filteredTags = allTegs?.filter(
    tag => tag.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const formatDate = isoDate => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    };
    const date = new Date(isoDate);
    return date.toLocaleDateString('ru-RU', options);
  };

  const convertToHHMMSS = isoTime => {
    const date = new Date(isoTime);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  // Функция для извлечения URL из markdown-ссылки
  const extractUrlFromMarkdown = (text) => {
    if (!text) return null;
    const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/;
    const match = text.match(markdownLinkRegex);
    if (match && match[2]) {
      // Возвращаем URL как есть, без декодирования, так как он может быть уже правильно закодирован
      return match[2];
    }
    return null;
  };

  // Функция для проверки, является ли файл PDF
  const isPdfFile = (url) => {
    if (!url) return false;
    return url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('/pdf');
  };

  // Настройка worker для react-pdf - используем jsdelivr CDN
  pdfjs.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

  // Компонент для отображения PDF как изображения
  const PdfViewer = ({ url, switcher }) => {
    const [error, setError] = useState(false);
    const [pdfData, setPdfData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [useIframe, setUseIframe] = useState(false);

    useEffect(() => {
      const loadPdf = async () => {
        try {
          setLoading(true);
          setError(false);
          setUseIframe(false);
          
          // Пробуем загрузить через fetch
          try {
            const response = await fetch(url, {
              method: 'GET',
              mode: 'cors',
              credentials: 'omit',
              redirect: 'follow'
            });
            
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const arrayBuffer = await response.arrayBuffer();
            setPdfData({ data: arrayBuffer });
            setLoading(false);
          } catch (fetchError) {
            console.warn('Fetch не удался, используем iframe:', fetchError);
            // Если fetch не работает, используем iframe
            setUseIframe(true);
            setLoading(false);
          }
        } catch (err) {
          console.error('Ошибка загрузки PDF:', err);
          setUseIframe(true);
          setLoading(false);
        }
      };

      if (url) {
        loadPdf();
      }
    }, [url]);

    function onDocumentLoadSuccess() {
      setError(false);
    }

    function onDocumentLoadError(error) {
      console.error('Ошибка парсинга PDF:', error);
      // Если react-pdf не работает, переключаемся на iframe
      setUseIframe(true);
      setError(false);
    }

    if (loading) {
      return (
        <div style={{
          marginTop: '8px',
          padding: '40px 20px',
          textAlign: 'center',
          background: switcher ? '#404040' : '#f9fafb',
          borderRadius: '12px',
          border: `1px solid ${switcher ? '#525252' : '#e5e7eb'}`
        }}>
          <div style={{
            color: switcher ? '#9ca3af' : '#6b7280',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            Загрузка PDF...
          </div>
        </div>
      );
    }

    // Если нужно использовать альтернативный способ (fallback)
    if (useIframe || (!pdfData && !loading)) {
      // Пробуем использовать Google Docs Viewer как прокси
      const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`;
      
      return (
        <div style={{ 
          marginTop: '8px',
          borderRadius: '12px',
          overflow: 'hidden',
          background: switcher ? '#2E2E2E' : '#ffffff',
          border: `1px solid ${switcher ? '#404040' : '#e5e7eb'}`,
          boxShadow: switcher ? '0 2px 8px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}>
          <iframe
            src={googleViewerUrl}
            style={{
              width: '100%',
              minHeight: '600px',
              border: 'none',
              display: 'block',
              background: switcher ? '#2E2E2E' : '#ffffff'
            }}
            title="PDF файл"
            onError={() => {
              // Если Google Viewer не работает, показываем ссылку
              setUseIframe(false);
            }}
          />
          <div style={{
            padding: '12px 16px',
            borderTop: `1px solid ${switcher ? '#404040' : '#e5e7eb'}`,
            background: switcher ? '#404040' : '#f9fafb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}>
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke={switcher ? '#9ca3af' : '#6b7280'} 
              strokeWidth="2"
              style={{ flexShrink: 0 }}
            >
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: switcher ? '#667eea' : '#2563eb',
                textDecoration: 'none',
                fontSize: '13px',
                fontWeight: '500',
                transition: 'color 0.2s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = switcher ? '#7c8ef5' : '#1d4ed8';
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = switcher ? '#667eea' : '#2563eb';
                e.target.style.textDecoration = 'none';
              }}
            >
              Открыть в новой вкладке
            </a>
          </div>
        </div>
      );
    }

    if (error && !useIframe) {
      return (
        <div style={{
          marginTop: '8px',
          padding: '40px 20px',
          textAlign: 'center',
          background: switcher ? '#404040' : '#f9fafb',
          borderRadius: '12px',
          border: `1px solid ${switcher ? '#525252' : '#e5e7eb'}`
        }}>
          <div style={{
            color: switcher ? '#9ca3af' : '#6b7280',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            Не удалось загрузить файл
          </div>
        </div>
      );
    }

    return (
      <div style={{ 
        marginTop: '8px',
        borderRadius: '12px',
        overflow: 'hidden',
        background: switcher ? '#2E2E2E' : '#ffffff',
        border: `1px solid ${switcher ? '#404040' : '#e5e7eb'}`,
        boxShadow: switcher ? '0 2px 8px rgba(0, 0, 0, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
        padding: '12px'
      }}>
        <Document
          file={pdfData}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          loading={
            <div style={{
              padding: '40px 20px',
              textAlign: 'center',
              color: switcher ? '#9ca3af' : '#6b7280',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              Загрузка PDF...
            </div>
          }
        >
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            background: switcher ? '#2E2E2E' : '#f9fafb',
            borderRadius: '8px',
            padding: '8px'
          }}>
            <Page
              pageNumber={1}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              scale={1.5}
              style={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: '8px',
                boxShadow: switcher ? '0 2px 8px rgba(0, 0, 0, 0.4)' : '0 2px 8px rgba(0, 0, 0, 0.1)'
              }}
            />
          </div>
        </Document>
      </div>
    );
  };

  const countDecisions = (results) => {
    if (!results || typeof results !== 'object') {
      return [];
    }

    return Object.entries(results).map(([user, decisions]) => {
      if (!Array.isArray(decisions)) {
        return { user, trueCount: 0, falseCount: 0 };
      }

      const counts = decisions.reduce(
        (acc, item) => {
          if (item.decision === true) {
            acc.trueCount += 1;
          } else if (item.decision === false) {
            acc.falseCount += 1;
          }
          return acc;
        },
        { trueCount: 0, falseCount: 0 }
      );

      return { user, ...counts };
    });
  };

  const countAllDecisions = data => {
    if (!data || typeof data !== 'object')
      return { trueCount: 0, falseCount: 0 };

    return Object.values(data).reduce(
      (acc, user) => {
        user?.results?.forEach(item => {
          if (item.decision) {
            acc.trueCount += 1;
          } else {
            acc.falseCount += 1;
          }
        });
        return acc;
      },
      { trueCount: 0, falseCount: 0 }
    );
  };

  const countAgentMessages = messages => {
    const counts = messages?.reduce((acc, message) => {
      if (message.author.type !== 'system') {
        const author = message.author.name;
        acc.byAuthor[author] = (acc.byAuthor[author] || 0) + 1;
        acc.total += 1;
      }
      return acc;
    }, { byAuthor: {}, total: 0 });

    return counts || { byAuthor: {}, total: 0 };
  };

  const decisions = countDecisions(agent?.results);
  const allDecisions = countAllDecisions(agent?.results);
  const messageCounts = countAgentMessages(agent?.messages);

  return (
    <>
      <ModalOverlay onClick={onClose}>
        <ModalContent switcher={switcher} onClick={(e) => e.stopPropagation()} ref={mainModalRef}>
          <ModalHeader switcher={switcher}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {/* Кнопка "Назад" */}
        {chats && chats.length > 1 && (
                <button
            onClick={goToPrevChat}
            disabled={currentChatIndex === 0}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '18px',
                    cursor: currentChatIndex === 0 ? 'not-allowed' : 'pointer',
                    color: currentChatIndex === 0 ? (switcher ? '#525252' : '#d1d5db') : (switcher ? '#ffffff' : '#111827'),
                    padding: '8px',
                    borderRadius: '6px',
                    transition: 'all 0.2s',
                    opacity: currentChatIndex === 0 ? 0.5 : 1
                  }}
            title="Предыдущий чат"
          >
            ←
                </button>
        )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <ModalTitle switcher={switcher}>
                  Детали чата #{agent?.thread_id || currentUserId}
                </ModalTitle>
                {/* Комментарий в заголовке */}
                {agent?.title_comment && (
                  <div style={{
                    fontSize: '12px',
                    color: switcher ? '#9ca3af' : '#6b7280',
                    fontStyle: 'italic',
                    fontWeight: 'normal'
                  }}>
                    {agent.title_comment}
                  </div>
                )}
              </div>

              {/* Счетчик чатов */}
        {chats && chats.length > 1 && (
                <div style={{
                  fontSize: '12px',
                  color: switcher ? '#9ca3af' : '#6b7280',
                  padding: '4px 8px',
                  background: switcher ? '#404040' : '#f3f4f6',
                  borderRadius: '12px',
                  fontWeight: '500'
                }}>
            {currentChatIndex + 1} из {chats.length}
                </div>
        )}

              {/* Кнопка "Вперед" */}
        {chats && chats.length > 1 && (
                <button
            onClick={goToNextChat}
            disabled={currentChatIndex === chats.length - 1}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: '18px',
                    cursor: currentChatIndex === chats.length - 1 ? 'not-allowed' : 'pointer',
                    color: currentChatIndex === chats.length - 1 ? (switcher ? '#525252' : '#d1d5db') : (switcher ? '#ffffff' : '#111827'),
                    padding: '8px',
                    borderRadius: '6px',
                    transition: 'all 0.2s',
                    opacity: currentChatIndex === chats.length - 1 ? 0.5 : 1
                  }}
            title="Следующий чат"
          >
            →
                </button>
              )}
            </div>
            <CloseButton switcher={switcher} onClick={() => onClose?.()}>
              ✕
            </CloseButton>
          </ModalHeader>

          <ModalBody switcher={switcher}>
            {/* Информация о чате */}
            <ChatInfoSection switcher={switcher}>
              <ChatInfoLeft>
                <ChatId>ID: {agent?.thread_id || currentUserId}</ChatId>
                <ChatStatus switcher={switcher}>
                  Статус:
                  <StatusIcon checked={agent?.checked} />
                  {agent?.checked ? 'Проверен' : 'Не проверен'}
                </ChatStatus>
                {/* Проверено пользователем */}

                  <div style={{
                    fontSize: '14px',
                    color: switcher ? '#9ca3af' : '#6b7280'
                  }}>
                    Проверено: <span style={{ fontWeight: '500', color: switcher ? '#d1d5db' : '#374151' }}>{agent?.checked_by || 'Не указано'}</span>
                    {agent?.project && (
                      <span style={{ marginLeft: '16px' }}>
                        Проект: <span style={{ fontWeight: '500', color: switcher ? '#d1d5db' : '#374151' }}>{agent.project}</span>
                      </span>
                    )}
                  </div>

                {agent?.comment && (
                  <div style={{
                    marginTop: '8px',
                    padding: '8px 12px',
                    background: switcher ? '#525252' : '#f3f4f6',
                    borderRadius: '6px',
                    border: `1px solid ${switcher ? '#404040' : '#e5e7eb'}`
                  }}>
                    <div style={{
                      fontSize: '12px',
                      fontWeight: '500',
                      color: switcher ? '#9ca3af' : '#6b7280',
                      marginBottom: '4px'
                    }}>
                      Комментарий к чату:
                    </div>
                    <div style={{
                      fontSize: '13px',
                      color: switcher ? '#d1d5db' : '#374151',
                      lineHeight: '1.4'
                    }}>
                      {agent.comment}
                    </div>
                  </div>
                )}
              </ChatInfoLeft>
              <UserStats>
                <StatItem>
                  <StatValue switcher={switcher}>{agent?.score || 0}</StatValue>
                  <StatLabel switcher={switcher}>Оценка</StatLabel>
                </StatItem>
                <StatItem>
                  <StatValue switcher={switcher}>{allDecisions.falseCount}</StatValue>
                  <StatLabel switcher={switcher}>Ошибки</StatLabel>
                </StatItem>
                <StatItem>
                  <StatValue switcher={switcher}>{allDecisions.trueCount}</StatValue>
                  <StatLabel switcher={switcher}>Правильно</StatLabel>
                </StatItem>
              </UserStats>
            </ChatInfoSection>

            {/* Информация о пользователе */}
            {agent?.username && (
              <UserSection switcher={switcher}>
                <UserAvatar src={imgTest} alt="User" />
                <UserInfo>
                  <UserName switcher={switcher}>{agent.username[0]}</UserName>
                  <UserRole switcher={switcher}>Агент поддержки</UserRole>
                  {/* Комментарий к агенту */}
                  {agent?.agent_comment && (
                    <div style={{
                      marginTop: '4px',
                      fontSize: '12px',
                      color: switcher ? '#9ca3af' : '#6b7280',
                      fontStyle: 'italic'
                    }}>
                      {agent.agent_comment}
                    </div>
                  )}
                </UserInfo>
                <UserStats>
                  <StatItem>
                    <StatValue switcher={switcher}>
                      {messageCounts?.byAuthor[agent.username[0]] || 0}
                    </StatValue>
                    <StatLabel switcher={switcher}>Сообщений агента</StatLabel>
                  </StatItem>
                  <StatItem>
                    <StatValue switcher={switcher}>
                      {messageCounts?.total || 0}
                    </StatValue>
                    <StatLabel switcher={switcher}>Всего сообщений</StatLabel>
                  </StatItem>
                </UserStats>
              </UserSection>
            )}

            {/* Прогресс бар */}
            <ProgressSection>
              <ProgressBar switcher={switcher}>
                <Progress
                  percent={agent?.score || 0}
                  switcher={switcher}
                />
          </ProgressBar>
            </ProgressSection>

            {/* Табы */}
            <TabContainer switcher={switcher}>
              <Tab
            active={activeTab === 'analytics'}
            onClick={() => setActiveTab('analytics')}
                switcher={switcher}
          >
            Аналитика
              </Tab>
              <Tab
            active={activeTab === 'chat'}
            onClick={() => setActiveTab('chat')}
                switcher={switcher}
              >
                Чат
              </Tab>
            </TabContainer>

            {/* Контент табов */}
            <TabContent>
      {activeTab === 'analytics' && (
          <AnalyticsList>
                  {/* Выбор пользователя */}
                  {Array.isArray(agent?.username) && agent.username.length > 0 && (
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '20px',
                      marginBottom: '20px',
                      padding: '16px',
                      background: switcher ? '#404040' : '#f9fafb',
                      borderRadius: '8px'
                    }}>
                      {agent.username.map((user, index) => (
                        <button
                    key={index}
                          onClick={() => setActiveUser(user)}
                          style={{
                            background: activeUser === user ? '#667eea' : 'transparent',
                            color: activeUser === user ? 'white' : (switcher ? '#ffffff' : '#111827'),
                            border: '1px solid #667eea',
                            borderRadius: '6px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                            fontWeight: activeUser === user ? '600' : '400'
                          }}
                        >
                          {user}
                        </button>
                      ))}
                  </div>
                  )}

                  {/* Анализ для активного пользователя */}
                  {activeUser && activeUserResault?.[activeUser] && (
                    <div style={{ marginBottom: '20px' }}>
                      <h3 style={{
                        margin: '0 0 10px 0',
                        color: switcher ? '#ffffff' : '#111827'
                      }}>
                        Анализ для {activeUser}
                      </h3>
                      <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                        marginBottom: '10px'
                      }}>
                        <span style={{ color: switcher ? '#9ca3af' : '#6b7280' }}>
                          Оценка: {activeUserResault[activeUser]?.score || 0}%
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Детальные результаты */}
                  {activeUser && Array.isArray(agent?.results?.[activeUser]?.results) && (
                    agent.results[activeUser].results.map((item, index) => (
                      <AnalyticsItem
                        key={index}
                        switcher={switcher}
                        onClick={() => toggleText(index)}
                      >
                        <AnalyticsItemHeader>
                          <AnalyticsItemTitle switcher={switcher}>
                          {item.question}
                          </AnalyticsItemTitle>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {item.decision === true ? <Plus /> : <Minus />}
                            <AnalyticsItemScore
                              score={item.decision ? 90 : 60}
                            >
                              {item.decision ? 'Правильно' : 'Ошибка'}
                            </AnalyticsItemScore>
                          </div>
                        </AnalyticsItemHeader>

                          {openTextIndex === index && (
                          <AnalyticsItemContent switcher={switcher}>
                            <TextBlock>
                            <CommentText>{item.explanation}</CommentText>
                            </TextBlock>
                          </AnalyticsItemContent>
                        )}

                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          marginTop: '8px'
                        }}>
                          {userDepartment !== 'Supports' && (
                            <ActionButton
                              variant="success"
                              onClick={(e) => {
                                e.stopPropagation();
                                openModal(item, agent);
                              }}
                              style={{ padding: '4px 8px', fontSize: '12px' }}
                            >
                              <DicisionIcon />
                              Комментарий
                            </ActionButton>
                          )}
                        </div>

                        {/* Комментарии и теги */}
                        {item?.manager_comment && (
                          <div style={{ marginTop: '8px', padding: '8px', background: switcher ? '#525252' : '#f3f4f6', borderRadius: '4px' }}>
                            <CommentText style={{ fontSize: '12px', margin: '0 0 4px 0' }}>
                              Комментарий:
                            </CommentText>
                            <TextBlock>
                              <CommentText style={{ fontSize: '12px', margin: '0' }}>
                                {item.manager_comment}
                              </CommentText>
                        </TextBlock>
                          </div>
                        )}

                        {item?.tags && item.tags.length > 0 && (
                          <div style={{ marginTop: '8px' }}>
                            <CommentText style={{ fontSize: '12px', margin: '0 0 4px 0' }}>
                              Теги:
                            </CommentText>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                              {item.tags.map((tag, tagIndex) => (
                                <span
                                  key={tagIndex}
                                  style={{
                                    fontSize: '10px',
                                    padding: '2px 6px',
                                    background: '#667eea',
                                    color: 'white',
                                    borderRadius: '10px'
                                  }}
                                >
                                  {tag?.name || tag}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </AnalyticsItem>
                    ))
                  )}
                </AnalyticsList>
              )}

              {activeTab === 'chat' && (
                <ChatContainer switcher={switcher}>
                  <div style={{
                    padding: '12px 16px',
                    borderBottom: `1px solid ${switcher ? '#525252' : '#e5e7eb'}`,
                    fontSize: '12px',
                    color: switcher ? '#9ca3af' : '#6b7280',
                    textAlign: 'center'
                  }}>
                    Начало чата - {formatDate(agent?.created_at)}
                  </div>
                  {agent?.messages?.map((message, index) => {
                    const isSystem = message.author.type === 'system';
                    const isBot = message.author.type === 'bot';
                    const isPrivate = message.private === true;
                    const authorType = isSystem ? 'system' : (isBot ? 'bot' : (message.author.type === 'agent' ? 'agent' : 'customer'));
                    const isFile = message.message_type === 'file';
                    const fileUrl = isFile ? extractUrlFromMarkdown(message.text) : null;
                    const isPdf = isFile && fileUrl && isPdfFile(fileUrl);
                    
                    return (
                      <MessageContainer key={index} switcher={switcher} authorType={authorType} isPrivate={isPrivate}>
                        <MessageBubble switcher={switcher} authorType={authorType} isPrivate={isPrivate}>
                          {!isSystem && (
                            <MessageHeader switcher={switcher} authorType={authorType}>
                              <MessageAuthor authorType={authorType} switcher={switcher}>
                                {message.author.name}
                              </MessageAuthor>
                              <MessageTime switcher={switcher} authorType={authorType}>
                                {convertToHHMMSS(message.created_at)}
                              </MessageTime>
                            </MessageHeader>
                          )}
                          <MessageContent switcher={switcher}>
                            {isFile && fileUrl ? (
                              <div style={{ marginTop: '8px' }}>
                                {isPdf ? (
                                  <PdfViewer url={fileUrl} switcher={switcher} />
                                ) : (
                                  <img 
                                    src={fileUrl} 
                                    alt="" 
                                    style={{
                                      maxWidth: '100%',
                                      height: 'auto',
                                      borderRadius: '8px',
                                      display: 'block'
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                )}
                              </div>
                            ) : !isFile ? (
                              message.text
                            ) : null}
                          </MessageContent>
                        </MessageBubble>
                      </MessageContainer>
                    );
                  })}
                </ChatContainer>
              )}
            </TabContent>

            {/* Кнопки действий */}
            <ActionButtons switcher={switcher}>
              <ActionButton
                variant="primary"
                onClick={ChangeChecked}
                disabled={userDepartment === 'Supports'}
              >
                <ResetIcon />
                {agent?.checked ? 'Отменить проверку' : 'Проверить'}
              </ActionButton>
            </ActionButtons>
          </ModalBody>
        </ModalContent>
      </ModalOverlay>

      {/* Модальное окно для комментариев */}
      {isModalOpen && (
        <CommentModal onClick={(e) => e.stopPropagation()}>
          <CommentModalContent
            ref={commentModalRef}
            switcher={switcher}
            onClick={(e) => e.stopPropagation()}
          >
            <ModalHeader switcher={switcher}>
              <ModalTitle switcher={switcher}>
                {modalData?.question || 'Добавить комментарий'}
              </ModalTitle>
              <CloseButton switcher={switcher} onClick={closeModal}>✕</CloseButton>
            </ModalHeader>

            <CommentForm onSubmit={handleSubmit}>
              <FormField>
                <Label switcher={switcher}>Решение:</Label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    name="decision"
                    checked={formData?.decision}
                    onChange={handleChange}
                  />
                  <span style={{ fontSize: '14px', color: switcher ? '#d1d5db' : '#6b7280' }}>
                    Решение принято
                  </span>
                </div>
              </FormField>

              <FormField>
                <Label switcher={switcher}>Комментарий:</Label>
                <TextArea
                  name="manager_comment"
                  value={formData?.manager_comment}
                  onChange={handleChange}
                  placeholder="Введите комментарий..."
                  switcher={switcher}
                />
              </FormField>

              <FormField>
                {!formData?.decision && (
                  <>
                    <Label switcher={switcher}>
                      Теги: {formData?.tags.map(tag => tag?.name).join(', ')}
                    </Label>

                    <div style={{ marginBottom: '12px' }}>
                      <h4 style={{
                        margin: '0 0 8px 0',
                        fontSize: '14px',
                        color: switcher ? '#ffffff' : '#111827'
                      }}>
                        Поиск тегов
                      </h4>
                      <Input
                        type="text"
                        placeholder="Поиск тегов..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        switcher={switcher}
                      />
                    </div>

                    <List>
                      {filteredTags?.map(error => (
                        <Item
                          key={error.id}
                          selected={formData?.tags.some(tag => tag.id === error.id)}
                          onClick={e => handleChange(e, error)}
                          switcher={switcher}
                        >
                          {error.name}
                        </Item>
                      ))}
                    </List>
                  </>
                )}
              </FormField>

              <SubmitButton type="submit">
                Сохранить
              </SubmitButton>
            </CommentForm>
          </CommentModalContent>
        </CommentModal>
      )}
    </>
  );
};

export default SupportMenu;
